module.exports = __webpack_public_path__ + "img/logo.8c13caa2.png";